"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var CodebookItemConverterImpl_1 = require("../../core/model/codebook/conversions/CodebookItemConverterImpl");

var Tier_1 = require("../model/Tier");

var TierConverter_1 = require("./TierConverter");
/**
 * Default implementation of TierConverter.
 *
 * @author JMe
 * @author Radek Beran
 */


var TierConverterImpl =
/*#__PURE__*/
function (_TierConverter_1$Tier) {
  _inherits(TierConverterImpl, _TierConverter_1$Tier);

  function TierConverterImpl() {
    var _this;

    _classCallCheck(this, TierConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TierConverterImpl).call(this));
    _this.codebookItemConverter = new CodebookItemConverterImpl_1.CodebookItemConverterImpl();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(TierConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new Tier_1.Tier(Tier_1.Tier.tierSchema.id.valueOf(conversions.documentToClassId(source)), Tier_1.Tier.tierSchema.title.valueOfField(source), Tier_1.Tier.tierSchema.level.valueOfField(source), Tier_1.Tier.tierSchema.description.valueOfField(source), Tier_1.Tier.tierSchema.isDefault.valueOfField(source), immutable_1.List(Tier_1.Tier.tierSchema.flags.valueOfField(source)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, this.codebookItemConverter.toDocument(source, conversions));
      Object.assign(document, {
        level: source.level,
        isDefault: source.isDefault
      });
      return document;
    }
  }]);

  return TierConverterImpl;
}(TierConverter_1.TierConverter);

exports.TierConverterImpl = TierConverterImpl;